/**
 * 이미지 주소를 같은 출처(/s3)로 바꾼다 (2026-10-05, 모바일 접속).
 *
 * 서버는 MinIO 프리사인 URL 을 `http://127.0.0.1:9010/...` 로 준다. PC 의 브라우저에서는 되지만,
 * 휴대폰에서 127.0.0.1 은 휴대폰 자신이라 사진이 전부 깨진다. 루프백 주소의 이미지는
 * `/s3/...` 로 바꿔 웹 서버(개발: Vite 프록시, 운영: Nginx)를 거쳐 받는다.
 * 프록시가 Host 를 원래 주소(127.0.0.1:9010)로 넘기므로 서명(SigV4)은 그대로 유효하다.
 */
const LOOPBACK = /^https?:\/\/(?:127\.0\.0\.1|localhost)(?::\d+)?\//;

export function mediaUrl(u?: string | null): string | undefined {
  if (!u) return undefined;
  return LOOPBACK.test(u) ? u.replace(LOOPBACK, '/s3/') : u;
}

/** srcset 문자열 안의 각 주소도 같은 규칙으로 */
export function mediaSrcSet(s?: string): string | undefined {
  if (!s) return undefined;
  return s.split(',').map((part) => {
    const [url, ...rest] = part.trim().split(/\s+/);
    return [mediaUrl(url), ...rest].join(' ');
  }).join(', ');
}
